import React, { FC } from 'react';
import cx from 'classnames';
import { ServiceHeader } from './ServiceHeader';
import iconFuelPump from '../../assets/iconFuelPump.svg';
import iconProTransport from '../../assets/iconProTransport.svg';
import iconFactoring from '../../assets/iconFactoring.svg';
import iconFreight from '../../assets/iconFreight.svg';
import { LearnMoreBtn } from '../LearnMoreBtn';
import styles from './repStyles.scss';
import { useIsRtsRebrand } from '../../../common/useRtsRebrand';
export const NoFeatures: FC<{ freightPermissionsFF: boolean }> = ({ freightPermissionsFF }) => {
  const isRebrand = useIsRtsRebrand();
  return (
    <div className={cx(styles.repCardsContainer, styles.flexColumn)}>
      <div className={styles.noFeaturesTitle}>
        {isRebrand ? 'You do not have additional features in RTS.' : 'You do not have additional features in RTS Pro.'}
      </div>
      <div className={styles.noFeatureSubtitle}>See how we can help you save money and grow your business!</div>
      <div className={styles.servicesContainer}>
        <div className={styles.serviceContainer}>
          <ServiceHeader icon={iconFuelPump} serviceName="Fuel" />
          <LearnMoreBtn target={'fuel'} />
        </div>
        <div className={styles.lineBorder} />
        <div className={styles.serviceContainer}>
          <ServiceHeader icon={iconFactoring} serviceName="Factoring" />
          <LearnMoreBtn target={'factoring'} />
        </div>
        <div className={styles.lineBorder} />
        {freightPermissionsFF && (
          <>
            <div className={styles.serviceContainer}>
              <ServiceHeader icon={iconFreight} serviceName="freight" />
              <LearnMoreBtn target={'factoring'} />
            </div>
            <div className={styles.lineBorder} />
          </>
        )}
        <div className={styles.serviceContainer}>
          <ServiceHeader icon={iconProTransport} serviceName="Freight" />
          <LearnMoreBtn target={'freight'} />
        </div>
      </div>
    </div>
  );
};
